const HOST = process.env.VITE_REST_API_HOST;

const GET_SURVEY_DETAIL = {
  method: 'GET',
  path: `${HOST}go_shared/survey/survey`
};
const SEND_SURVEY_RESULT = {
  method: 'POST',
  path: `${HOST}go_shared/survey/survey/results`
};

export default {
  GET_SURVEY_DETAIL,
  SEND_SURVEY_RESULT
};
